import React from "react"
import { Input, Button, Table, Space, Select, Form, Radio, TreeSelect, InputNumber, message } from 'antd'
import Modal from "antd/lib/modal/Modal"
import { FormInstance } from "antd/lib/form"
import { SearchOutlined, RedoOutlined, PlusOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosNoInfo } from '../../tool/axios'
import baseAxios from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import { SelectStores } from "../../component/common/Selects"
import getPermission from '../../js/permission'
import { formItemLayout, tailLayout } from '../../js/globalParam'

const { Column } = Table
const { Option } = Select

const formFormat = {
    store_list: '',
    item_type: '',
    item_list: '',
    item_old_price: '',
    item_latest_price: '',
    order_level: '',
}

interface State {
    data: object[],
    store_name: string,
    item_name: string,
    chankang_item_type_desc: string,
    showType: string,
    treeData: object[],
    item_list: [],
    loading: boolean,

    pagination: {
        current: number,
        pageSize: number,
        total: number,
        showSizeChanger: boolean
    },

    fetchOtherParams: {
        store_id: string | undefined,
        store_name: string | undefined,
        item_type_list_id: string | undefined,
        item_types: any,
        item_name: string | undefined,
        item_status: string | undefined
        chankang_item_type: string | undefined
    },

    formParams: {
        item_type: string | null
    },

    offShelfVisible: boolean,
    addVisible: false,
    selectStoreData: {}[],
    selectProjectChildData: {}[],
    typeID: string,
    activeID: number | string,
    activeStatus: number,
    permissionList: string[]
}

export default class SetUpProduct extends React.Component {
    state: State = {
        data: [],
        showType: 'add',
        store_name: '',
        item_name: '',
        chankang_item_type_desc: '',
        item_list: [],
        selectStoreData: [],
        selectProjectChildData: [],
        treeData: [],
        loading: false,

        pagination: {
            current: 1,
            pageSize: 8,
            total: 0,
            showSizeChanger: false
        },

        fetchOtherParams: {
            store_id: undefined,
            store_name: undefined,
            item_type_list_id: undefined,
            item_types: '1,2',
            item_name: undefined,
            item_status: undefined,
            chankang_item_type: undefined
        },

        formParams: {
            item_type: null
        },

        offShelfVisible: false,
        addVisible: false,
        activeID: '',
        typeID: '',
        activeStatus: 0,
        permissionList: []
    }

    inputRef = React.createRef<any>()
    formRef = React.createRef<FormInstance>()

    componentDidMount() {
        this.setState({
            permissionList: getPermission()
        })

        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
        this.getStores()
    }

    handleInputChange(e: any) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.store_name = e.target.value

        this.setState({ fetchOtherParams })
    }

    handleInputChange2(e: any) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.item_name = e.target.value

        this.setState({ fetchOtherParams })
    }

    handleTreeSelectChange(value: string[]) {
        this.setState({
            item_list: value.length ? value : []
        })

        this.formRef.current?.setFieldsValue({ item_list: value })
    }

    handleSelectChange2(value: string) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.chankang_item_type = value

        this.setState({ fetchOtherParams })
    }

    changeStores(value: string) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.store_id = value

        this.setState({ fetchOtherParams })
    }

    changeCancel() {
        this.resetForm()
        this.setState({ addVisible: false })
    }

    handleSelectStatus(value: string) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.item_status = value

        this.setState({ fetchOtherParams })
    }

    handleSearch() {
        let { pagination, fetchOtherParams } = this.state
        pagination.current = 1

        this.setState({ pagination }, () => {
            this.fetch({ pagination, fetchOtherParams })
        })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: any }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        if (fetchOtherParams.item_type_list_id) {
            fetchOtherParams.item_type = 1
        }

        axiosTable.get('/chankang_center/store_item/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            if (response) {
                const { pagination } = this.state
                pagination.total = response.total
                pagination.pageSize = response.size
                pagination.current = response.current

                this.setState({
                    pagination,
                    data: response.records
                })
            }
        })
    }

    resetForm() {
        for (let attr in formFormat) { this.formRef.current?.setFieldsValue({ [attr]: '' }) }
    }

    resetParams() {
        let { pagination, fetchOtherParams } = this.state
        pagination.current = 1

        fetchOtherParams = {
            store_id: undefined,
            store_name: undefined,
            item_type_list_id: undefined,
            item_types: '1,2',
            item_name: undefined,
            item_status: undefined,
            chankang_item_type: undefined
        }

        this.setState({
            pagination,
            fetchOtherParams
        })

        this.fetch({ pagination, fetchOtherParams })
    }

    refetch() {
        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
        this.setState({ addVisible: false })
    }

    onRadioChange(e: any) {
        if (e.target.value === 1) {
            this.getItemSingle()
        }

        if (e.target.value === 2) {
            this.getProjects()
        }
    }

    getStores() {
        baseAxiosNoInfo('/global/store_list_by_employee').then(res => {
            this.setState({ selectStoreData: res })
        })
    }

    getProjects() {
        baseAxiosNoInfo('/global/item_list', { params: { item_type: 2 } }).then(res => {
            if (res) this.setState({ selectProjectChildData: res })
        })
    }

    getItemSingle() {
        baseAxiosNoInfo.get('/chankang_center/item_single/select_list').then((response: any) => {
            if (response) {
                response.forEach((el: { singles: any[], id: string }) => {
                    el.singles.forEach(el2 => {
                        if (el2.item_id) {
                            Object.assign(el2, { item_id: el2.item_id, standard_times: el2.standard_times })
                        }
                    })
                })

                this.setState({
                    treeData: this.translateToTreeData(response)
                })
            }
        })
    }

    translateToTreeData(data: any) {
        return data.map((el: any) => ({
            title: el.item_type_name, // '产康分类1'
            value: el.item_type_id, // '0-0'
            key: el.item_type_id, // '0-0'
            disabled: el.singles.length ? false : true,
            children: el.singles.map((el: { item_id: string, item_name: string }) => ({
                title: el.item_name, // '项目1'
                value: el.item_id, //  '0-0-0'
                key: el.item_id, // '0-0-0'
            }))
        }))
    }

    showAdd() {
        this.getItemSingle()

        this.setState({ addVisible: true, activeID: null, showType: 'add' }, () => {
            this.formRef.current?.setFieldsValue({ item_type: 1 })

            if (this.state.showType == 'add') {
                this.formRef.current?.setFieldsValue({ store_list: undefined })
            }
        })

        this.resetForm()
    }

    showEdit(record: any) {
        baseAxiosNoInfo.get('/chankang_center/store_item/detail', { params: { store_item_id: record.store_item_id } }).then((response: any) => {
            this.setState({
                store_name: record.store_name,
                item_name: record.item_name,
                chankang_item_type_desc: record.chankang_item_type_desc,
            })

            this.setState({ showType: 'edit', addVisible: true, activeID: record.store_item_id }, () => {
                this.formRef.current?.setFieldsValue({
                    order_level: response.order_level,
                    item_old_price: response.item_old_price,
                    item_latest_price: response.item_latest_price,
                    store_list: response.store_list
                })
            })
        })
    }

    confirmAdd(values: any) {
        let data = {
            store_list: values.store_list,
            item_type: this.formRef.current?.getFieldValue('item_type'),
            item_list: this.state.item_list,
            item_old_price: this.formRef.current?.getFieldValue('item_old_price'),
            item_latest_price: this.formRef.current?.getFieldValue('item_latest_price'),
            order_level: this.formRef.current?.getFieldValue('order_level'),
        }

        if (this.formRef.current?.getFieldValue('item_old_price') == 0) {
            message.warning('原价不能为0 !')
            return false
        }

        if (this.formRef.current?.getFieldValue('item_latest_price') == 0) {
            message.warning('优惠价不能为0 !')
            return false
        }

        if (!this.state.activeID) { // 新增
            baseAxios.post('/chankang_center/store_item/add', data).then(res => { this.setState({ addVisible: false }) }).then(res => {
                this.refetch()
            })

        } else { // 编辑
            baseAxios.post('/chankang_center/store_item/update', {
                id: this.state.activeID,
                store_item_id: this.state.activeID,
                ...data
            }).then(res => {
                this.refetch()
            })
        }
    }

    // 金额输入框小数点控制后两位
    limitDecimals(value: any) {
        const reg = /^(\-)*(\d+)\.(\d\d).*$/;
        // 取数字
        const data = value.replace(/[^0-9.]/g, "")

        // 取小数点后两位
        return data.replace(reg, '$1$2.$3')
    }

    confirmOffShelf() {
        baseAxios.post('/chankang_center/store_item/on_off', {
            store_item_id: this.state.activeID,
            item_status: this.state.activeStatus
        }).then(res => {
            const { pagination, fetchOtherParams } = this.state

            this.fetch({ pagination, fetchOtherParams })
            this.setState({ offShelfVisible: false })
        })
    }

    offShelf(row: any, activeStatus: number) {
        this.setState({ offShelfVisible: true, activeID: row.store_item_id, activeStatus })
    }

    render() {
        let { item_name, item_status, chankang_item_type, store_id } = this.state.fetchOtherParams
        let StoreOptions = this.state.selectStoreData.map((el: any) => (<Option value={el.store_id} key={el.store_id}>{el.store_name}</Option>))
        let projectChildOptions = this.state.selectProjectChildData.map((el: any) => (<Option value={el.id} key={el.id}>{el.item_name}</Option>))

        let showType = this.state.showType
        let treeData = this.state.treeData

        let permissionList = this.state.permissionList

        return (<div className="common-page">
            {/* 产康中心 -> 产康项目管理 -> 门店上架管理 */}
            <BreadCrumb position={['产康中心', '门店上架管理']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <div style={{ marginRight: 8, marginBottom: 12 }}>
                        <SelectStores value={store_id} valueProp="id" onChange={this.changeStores.bind(this)} />
                    </div>
                    <Select style={{ marginRight: 8, marginBottom: 12, width: 120 }} onChange={this.handleSelectChange2.bind(this)} placeholder="项目类型" value={chankang_item_type} >
                        <Option value="1">产康单项</Option>
                        <Option value="2">产康套餐</Option>
                    </Select>
                    <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="项目名称" value={item_name} onChange={this.handleInputChange2.bind(this)} />
                    <Select style={{ marginRight: 8, marginBottom: 12, width: 120 }} onChange={this.handleSelectStatus.bind(this)} placeholder="状态" value={item_status} >
                        <Option value="1">已上架</Option>
                        <Option value="2">已下架</Option>
                    </Select>
                </Space>

                <div style={{ marginTop: 10 }}>
                    {permissionList.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={this.handleSearch.bind(this)}>查询</Button>}
                    <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={this.resetParams.bind(this)} icon={<RedoOutlined />}>重置</Button>
                    {permissionList.includes('添加') && <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" icon={<PlusOutlined />} onClick={this.showAdd.bind(this)}>添加</Button>}
                </div>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} pagination={this.state.pagination} rowKey="store_item_id" onChange={this.handleTableChange}>
                    <Column title="门店" dataIndex="store_name" key="store_name" />
                    <Column title="项目类型" dataIndex="chankang_item_type_desc" key="chankang_item_type_desc" />
                    <Column title="项目名称" dataIndex="item_name" key="item_name" />
                    <Column title="项目原价" dataIndex="item_old_price" key="item_old_price" />
                    <Column title="项目优惠价" dataIndex="item_latest_price" key="item_latest_price" />
                    <Column title="上架人" dataIndex="on_user_name" key="on_user_name" />
                    <Column title="上架时间" dataIndex="on_time" key="on_time" />
                    <Column title="下架人" dataIndex="off_user_name" key="off_user_name" />
                    <Column title="下架时间" dataIndex="off_time" key="off_time" />
                    <Column title="状态" dataIndex="item_status_desc" key="item_status_desc" />

                    <Column
                        title="操作"
                        key="action"
                        render={(text: string, record: any) => {
                            return <Space size="middle">
                                {permissionList.includes('编辑') && <Button type="primary" onClick={this.showEdit.bind(this, record)} >编辑</Button>}

                                {permissionList.includes('上下架') && <Space>
                                    {record.item_status_desc === '已上架' ? <Button onClick={this.offShelf.bind(this, record, 2)} >下架</Button> : <Button onClick={this.offShelf.bind(this, record, 1)} >上架</Button>}
                                </Space>}
                            </Space>
                        }}
                    />
                </Table>
            </div>

            {/* 新增或编辑的弹框 */}
            <Modal title={showType == 'add' ? '新增上架' : '编辑上架'} visible={this.state.addVisible} onCancel={this.changeCancel.bind(this)} footer={false} width="600px">
                <Form {...formItemLayout} ref={this.formRef} name="validate_other" onFinish={this.confirmAdd.bind(this)} >
                    {showType == 'add' && <Form.Item label="选择项目类型" name="item_type" >
                        <Radio.Group onChange={this.onRadioChange.bind(this)} >
                            <Radio value={1}>产康单项</Radio>
                            <Radio value={2}>产康套餐</Radio>
                        </Radio.Group>
                    </Form.Item>}

                    {showType == 'add' && <Form.Item label="选择门店" name="store_list" rules={[{ required: true, message: '必须选择门店' }]} >
                        <Select virtual={false} mode="multiple">{StoreOptions}</Select>
                    </Form.Item>}

                    {showType == 'add' && <Form.Item label="选择项目" name='item_list' rules={[{ required: true, message: '选择项目' }]} >
                        {this.formRef.current?.getFieldValue('item_type') === 1 && <TreeSelect showSearch treeData={treeData} treeCheckable={true} onChange={this.handleTreeSelectChange.bind(this)} filterTreeNode={(inputValue: any, treeNode: any) => (treeNode.title.indexOf(inputValue) != -1)} />}
                        {this.formRef.current?.getFieldValue('item_type') === 2 && <Select virtual={false} mode="multiple" onChange={this.handleTreeSelectChange.bind(this)}>  {projectChildOptions} </Select>}
                    </Form.Item>}

                    {showType == 'edit' && <Form.Item label="门店">{this.state.store_name}</Form.Item>}
                    {showType == 'edit' && <Form.Item label="项目类型">{this.state.chankang_item_type_desc}</Form.Item>}
                    {showType == 'edit' && <Form.Item label="项目名称">{this.state.item_name}</Form.Item>}

                    <Form.Item label="设置原价" name="item_old_price" rules={[{ required: true, message: '必须设置原价' }]} >
                        <InputNumber style={{ width: '100%' }} formatter={value => this.limitDecimals(value)} placeholder="请填写原价" />
                    </Form.Item>

                    <Form.Item label="设置优惠价" name="item_latest_price" rules={[{ required: true, message: '必须填写优惠价' }]}>
                        <InputNumber style={{ width: '100%' }} formatter={value => this.limitDecimals(value)} placeholder="请填写优惠价" />
                    </Form.Item>

                    <Form.Item label="排序" name="order_level" rules={[{ required: true, message: '必须排序' }]}>
                        <Input placeholder="" />
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit">提交</Button>
                    </Form.Item>
                </Form>
            </Modal>

            {/* 上下架确认框 */}
            <Modal title="确认提示" visible={this.state.offShelfVisible} onOk={this.confirmOffShelf.bind(this)} onCancel={() => { this.setState({ offShelfVisible: false }) }}>
                <div>是否{this.state.activeStatus == 1 ? '上架' : '下架'}该项目？</div>
            </Modal>
        </div>)
    }
}